import { EPR_PRODUCT_DATA } from '../../constants';

export const initialState = {
  selectedComponent: EPR_PRODUCT_DATA.radioButtonWithMultipleFilters, // variable for selected radio component
  isDisplay: false, // variable for display
  hardwareClasses: [], // An array to store the hardware classes
  productType: [], // An array to store the product type
  producCodeContains: [], // An array to store the product code contains
  productName: [], // An array to store the product name
  selectedRowData: null, // variable for selected row data
  displayButtonValue: false, // variable for display button value
  errorModal: null,
  alertBoxValue: false,
  hardwareSearchTerm: '',
  productTypeSearhTerm: '',
  productNameSearchTerm: '',
  productCodeContainSearchTerm: '',
  productCode: '',
  showSearchTerm: false, // variable for show search term
  showProductCodeSelectedValue: null,
  showProductnameSelectedValue: null,
  showProductTypeSelectedValue: null,
  showHardwareClassSelectedValue: {
    name: EPR_PRODUCT_DATA.initialSelectValueForAny,
    value: 0,
  },
  selectedValue: {
    productCode: '',
    productName: '',
    productTypeId: 0,
    productActive: 'y',
    productOrderable: 'a',
    productUnsupported: 'a',
    productWIPAssigment: 'a',
    hardwareClassId: 0,
    recordCount: 25,
    pageIndex: 1,
    exactMatch: false,
    priceClassContains: '',
  }, // variable for selected value
  dropDownValues: {
    productActive: EPR_PRODUCT_DATA.dropDownDefaultValueForYes,
    productOrderable: EPR_PRODUCT_DATA.dropDownDefaultValueForAny,
    productUnsupported: EPR_PRODUCT_DATA.dropDownDefaultValueForAny,
    productWIPAssigment: EPR_PRODUCT_DATA.dropDownDefaultValueForAny,
    productTypeId: EPR_PRODUCT_DATA.intdropDownDefaultValueForAny,
  }, // variable for drop down values
  searchResult: [], // An array to store the search result
  searhResultForDataGrid: [], // An array to store the search result for data grid
  loading: false,
  loadingForSearch: false,
  isResultFound: false,
  inputError: null,
  priceClassContainSearchTerm: '',
  showPriceClassSelectedValue: null,
  priceClassContains: [],
  generalInfoTabData: [],
  generalInfoLoading: false,
  productFamilyData: [],
  productFamilyLoading: false,
  salesInfoTabData: [],
  salesInfoLodading: false,
  salesInfoTotalCount: 0,
  serviceInfoTabModelData: [],
  totalCountForModel: 0,
  serviceInfoModelLoading: false,
  serviceInfoTabSubModelData: [],
  totalCountForSubModel: 0,
  serviceInfoSubModelLoading: false,
  serviceFeeData: null,
  serviceFeeGridData: [],
  serviceFeeGridLoading: false,
  hardwareFeeTotalCount: 0,
  serviceFeeResponse: null,
  serviceProductData: null,
  endOfServicGridData: [],
  endOfServceLoading: false,
  endOfServiceTotalCount: 0,
  generalInfoSaveResponse: null,
  saveModesNSubModelsResponse: null,
  saveServiceInfoFeeResponse: null,
  saveEndOfServiceResponse: null,
  servceInfoModelBody: null,
  serviceInfoSubModelBody: null,
  endOfServiceBody: {},
  serviceModelDateValidationData: null,
  serviceSubModelDateValidationData: null,
  oldObjGeneralInfo: {},
  oldObhServiceInfoModel: {},
  oldObjServiceInfoSubModel: {},
  oldObjServiceInfoFee: {},
  oldObjServiceInfoEndOfService: {},
  selectedRowForModel: null,
  serviceInfoModelDataFound: null,
  oldDateEndOfService: null,
  eosJobRunData: null,
  eosJobRunLoad: false,
  showAlert: false,
  entitlementFlag: false,
  ModelInfoFlag: false,
  FeeFlag: false,
  EndOfServiceFlag: false,
  EosModelGridData: [],
  AcceptButtonResponse: null,
  addExceptionBtn: false,
  callOldDateApi: false,
  receivedOldEos: false,
  latestEos: false,
  saveAndCloseButton: false,
  oldDateEndOfServiceForJob: null,
};
